import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
export default function GlobalModal(_param) {
    var title = _param.title, subTitle = _param.subTitle, btnText = _param.btnText, props = _object_without_properties(_param, [
        "title",
        "subTitle",
        "btnText"
    ]);
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useState = _sliced_to_array(useState({
        icon: "/icons/error-icon.png"
    }), 2), theme = _useState[0], setTheme = _useState[1];
    useEffect(function() {
        if (modalObj.icon === "error") {
            setTheme(_object_spread_props(_object_spread({}, theme), {
                icon: "/icons/error-icon.png"
            }));
        } else {
            setTheme(_object_spread_props(_object_spread({}, theme), {
                icon: "/icons/success-icon.png"
            }));
        }
    }, [
        modalObj.icon
    ]);
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        children: /*#__PURE__*/ _jsxs(Modal.Body, {
            className: "global-modal",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "px-3 py-4",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-center mb-4",
                            children: /*#__PURE__*/ _jsx("img", {
                                className: "modal-icon mx-auto",
                                src: theme.icon,
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-center fs-22 tc-6",
                            children: title
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-center fs-14 tc-7",
                            children: subTitle
                        })
                    ]
                }),
                btnText && /*#__PURE__*/ _jsx("div", {
                    className: "d-flex justify-content-center",
                    children: /*#__PURE__*/ _jsx(Button, {
                        onClick: function() {
                            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                                visible: false
                            }));
                        },
                        className: "modal-btn w-fit mb-2",
                        children: btnText
                    })
                })
            ]
        })
    }));
}
